export default __webpack_public_path__ + "static/media/video_bg_section1_mobile.3cb65120.mp4";